<div class="row">
  <ng-container *ngIf="loggedUserInfo.role === CodeRole.SUPERADMIN">
    <div class="col-12">
        <label for="">{{ 'product_sales.reseller'| translate }}</label>
        <angular2-multiselect (onSelect)="onResellerSelect($event)"
            [data]="resellerList"
            [(ngModel)]="resellerSelected"
            [settings]="computedSettings">
        </angular2-multiselect>
    </div>
  </ng-container>
  <div class="col-12" *ngIf="loggedUserInfo.role === CodeRole.COMPANY_ADMIN">
    <label for="">{{'base.rivendita' | translate}}</label>
    <angular2-multiselect (onSelect)="onResellerSelect($event)"
        [data]="resellerList"
        [(ngModel)]="resellerSelected"
        [settings]="computedSettings">
    </angular2-multiselect>
  </div>
</div>
